<!-- QR 찍으면 나오는 페이지 -->
<div *ngIf="ticket$ | async as ticket" class="qr-info-content">
  <p class="qr-info-tit">
    {{ ticket.productId?.name }}
  </p>

  <div class="qr-info-list">
    <div class="qr-info-item">
      <p class="itemtit">본인인증 정보</p>
      <ul>
        <li>
          <div class="tit">이름</div>
          <div class="con">{{ ticket.uuid?.name }}</div>
        </li>
        <li>
          <div class="tit">생년월일</div>
          <div class="con">{{ ticket.uuid?.birthDate | date : 'yyyy년 MM월 dd일' }}</div>
        </li>
        <li>
          <div class="tit">성별</div>
          <div class="con">{{ ticket.uuid?.gender ? (ticket.uuid?.gender === 'male' ? '남성' : '여성') : '-' }}</div>
        </li>
      </ul>
    </div>
    <div class="qr-info-item">
      <p class="itemtit">공연 정보</p>
      <ul>
        <li>
          <div class="tit">공연일시</div>
          <div class="con">
            {{ ticket.resDate | date : 'yyyy년 MM월 dd일 (E요일)' }} <br />
            {{ ticket.resDate | date : 'HH시 mm분' }} {{ getRound(ticket) }}
          </div>
        </li>
        <li>
          <div class="tit">공연장소</div>
          <div class="con">{{ ticket.productId?.addressDetail }}</div>
        </li>
        <li>
          <div class="tit">권종/매수</div>
          <div class="con">
            <p *ngFor="let sale of ticket.salePrice">{{ sale.name }} {{ sale.amount }}매</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="qr-info-item">
      <p class="itemtit">예매 정보</p>
      <ul>
        <li>
          <div class="tit">예매번호</div>
          <div class="con">{{ ticket.resNumber }}</div>
        </li>
        <li>
          <div class="tit">예매일</div>
          <div class="con">{{ ticket.payDate | date : 'yyyy년 MM월 dd일 E요일' }}</div>
        </li>
        <li>
          <div class="tit">예매금액</div>
          <div class="con">{{ ticket.totalPrice | number }}원</div>
        </li>
        <li>
          <div class="tit">결제방법</div>
          <div class="con">{{ paymentService.displayMethod(ticket.paymentMethod) }}</div>
        </li>
        <li>
          <div class="tit">결제상태</div>
          <div class="con">{{ paymentService.displayStatus(ticket.payStatus) }}</div>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isShowDate(ticket)" class="footer-btn-area">
    <button (click)="checkButton()" [disabled]="ticket.isEnter" class="footer-btn" type="button">
      <p *ngIf="!ticket.isEnter">입장처리<br />*직원확인용 버튼*</p>
      <p *ngIf="ticket.isEnter">입장 완료</p>
    </button>
  </div>
</div>
